import { createDecorator } from '../../instantiation/common/instantiation.js';
export const IClipboardService = createDecorator('clipboardService');